import React, { forwardRef, useState, useMemo, useEffect } from "react";
import "../../Styles/CommonStyles.scss";
import "../../Styles/TableStyles.scss";
import Select from "react-select";
import { useTable, Column, useSortBy, Row, useRowSelect } from "react-table";
import { COLUMNS, dummy_COLUMNS } from "./FindMemberListColumns";
import MemberServices from "../../services/MemberServices";
import moment from "moment";
import { fileSave } from "browser-fs-access";
import { Link, useNavigate } from "react-router-dom";
import MemberDetail from "../MemberDetail/MemberDetail";
import { useDispatch, useSelector } from "react-redux";
import {
  changeCurrentMemberMenu,
  changeisNavigationFromEventToMember,
} from "../../store/screenSlice";
import { screenConfig } from "../../config/screenConfig";
import {
  setMemberCurrentPage,
  setMemberPaginate,
  setUpdateSortBy,
  setUpdateSortType,
  updateFM_MemberId,
} from "../../store/memberApiSlice";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import OrderIcon from "../../Images/MemberIconComp/OrderIcon";
import LeftArrowIcon from "../../Images/LeftArrowIcon";
import AlertIcon from "../../Images/Alert";
import {
  resetSearchParameters,
  initialState,
  IState,
} from "../../store/searchMemberApiSlice";
import {
  Button,
  RoundButton,
  SecondaryWhiteButton,
} from "../StyledComp/StyledComp";
import {
  findMemberSearchResultSlice,
  findMembers,
} from "../../store/findMemberSearchResultSlice";
import currentMemberSlice, {
  assignCurrentMember,
} from "../../store/currentMemberSlice";
import { RootState } from "../../store/store";
import ReactModal from "react-modal";
import {
  updateMemberList,
  resetParameters,
} from "../../store/findMemberUpdatedApiSlice";
import DownloadIcon from "../../Images/MenuIconComp/download";
import FindMemberMenu from "./FindMemberMenu";
import dayjs from "dayjs";
import { resetSearchParamFlags } from "../../store/hasSearchParamFlags";
import { AnyARecord } from "dns";
import RoundButtonWithIcon from "../StyledComp/RoundButtonWithIcon";
import IMember from "../../store/memberInterfaceStruct";
import * as routeConfig from "../../config/routes";
import PrintIcon from "../../Images/MemberIconComp/PrintIcon";
import EmailIcon from "../../Images/MemberIconComp/EmailIcon";
import FindMemberIcon from "../../Images/MemberIconComp/FindMemberIcon";
import AlertWithModal from "../utilityComponents/AlertWithModal";

interface IConfiguration {
  [key: string]: any;
}

interface ImemberSections {
  Fee: number;
  Id: number;
  SectionDescription: string;
  SectionName: string;
  Status: number;
}

interface IPagination {
  TotalRecords: number;
  TotalAPIPages: number;
}

const FindMemberList: React.FC = () => {
  // const memberList = useAppSelector((state) => state.findMemberList);
  const [refreshCount, setRefreshCount] = useState(0);
  const [memberList, setMemberList] = useState<IMember[]>([]);
  const [CurrentMemberListPage, setCurrentMemberListPage] = useState<IMember[]>(
    []
  );
  const [includePrimaryAddress, setIncludePrimaryAddress] =
    useState<boolean>(false);
  const [includePublishedAddress, setIncludePublishedAddress] =
    useState<boolean>(false);
  const [includeAdminAddress, setIncludeAdminAddress] =
    useState<boolean>(false);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);


  const handleDownloadOption = async (option: string) => {
    setIsDownloadModalOpen(false);
    
    if (isLoading) return;
    setIsLoading(true);
    try {
      if(option === 'zip') {
        
        console.log("Fetching member report...");
        const response = await MemberServices.downloadPendingInvoices(
          memberListAPIParams
        );

        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Error");
          setAlertBody(response.data.errors[0]);
          return;
        }

        const url = response.data.data;
        const a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.click();
        
        console.log("File download triggered");
      }else {
        const response = await MemberServices.downloadMergedPendingInvoices(
          memberListAPIParams
        );

        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Error");
          setAlertBody(response.data.errors[0]);
          return;
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `merged_pending_invoices_${new Date().getTime()}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
      
    } catch (err) {
      console.error("Download failed:", err);
      setShowAlertModal(true);
      setAlertTitle("Error");
      setAlertBody("Something went wrong during download.");
    } finally {
      setIsLoading(false);
    }
  };

  const sectionNameArray = useSelector(
    (state: RootState) => state.searchMemberApiSlice.SectionIn ?? []
  );
  const executeNameArray = useSelector(
    (state: RootState) => state.searchMemberApiSlice.SectionNotIn ?? []
  );
  const tagsIn = useSelector(
    (state: RootState) => state.searchMemberApiSlice.TagIn ?? []
  );
  const tagsNotIn = useSelector(
    (state: RootState) => state.searchMemberApiSlice.TagsNotIn ?? []
  );
  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );
  const updateSortType = useSelector(
    (state: RootState) => state.memberApiSlice.SortType
  );
  const [SortType, setSortType] = useState(updateSortType);
  const updateSortBy = useSelector(
    (state: RootState) => state.memberApiSlice.SortBy
  );

  const [SortField, setSortField] = useState(updateSortBy);
  // const currentPage = useSelector(
  //   (state: RootState) => state.memberApiSlice.CurrentPage
  // );
  const currentPage = useSelector(
    (state: RootState) => state.memberApiSlice.CurrentPage
  );
  console.log(currentPage);
  const updatePage = useSelector(
    (state: RootState) => state.memberApiSlice.Paginate
  );
  const [CurrentPage, setCurrentPage] = useState(currentPage);
  const [CurrentAPICallPage, setCurrentAPICallPage] = useState(currentPage);
  // const [MembersPerAPICall, setMembersPerAPICall] = useState(1000);
  const [MembersPerPage, setMembersPerPage] = useState(updatePage);
  const [Pagination, setPagination] = useState<IPagination[]>();
  const [TotalRecords, setTotalRecords] = useState(0);
  const [TotalAPIPages, setTotalAPIPages] = useState(0);
  useState<boolean>(false);

  const [isClearSearchCalled, setIsClearSearchCalled] =
    useState<boolean>(false);
  const [NoOfSelectedMembers, setNoOfSelectedMembers] = useState<number>(0);

  const [isAllSelected, setIsAllSelected] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  let startIndex = 0;
  let endIndex = 0 + MembersPerPage;

  const currentYear = dayjs().month() < 6 ? dayjs().year() - 1 : dayjs().year();
  const currentFiscalYearStart = dayjs(`${currentYear}-07-01`).startOf("day");
  const [selectEmailOptionsModalOpen, setSelectEmailOptionsModalOpen] =
    useState<boolean>(false);
  console.log("currentYear:", currentYear);
  console.log("currentFiscalYearStart:", currentFiscalYearStart);
  console.log("FindMemberList refreshCount", refreshCount);
  const dispatch = useAppDispatch();

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  const navigate = useNavigate();
  const columns = React.useMemo<Column<any>[]>(
    () => [
      { id: "BarId", Header: "BarID", accessor: "BarId" },
      { id: "FirstName", Header: "FirstName", accessor: "FirstName" },
      { id: "LastName", Header: "LastName", accessor: "LastName" },
      { id: "MemberCode", Header: "MemberCode", accessor: "MemberCode" },
      { id: "MemberType", Header: "MemberType", accessor: "MemberType" },
      // { id: "Phoneno", Header: "Phone Number", accessor: "Phoneno" },
      // { id: "Gender", Header: "Gender", accessor: "Gender" },
      {
        id: "AdmitDate",
        Header: "AdmitDate",
        accessor: (AdmitDate) => {
          return moment(AdmitDate.AdmitDate).local().format("MM-DD-YYYY");
        },
      },
      { id: "MemberStatus", Header: "Status", accessor: "MemberStatus" },
      {
        id: "LastPaidDueDate",
        Header: "Last Paid Dues Date",
        accessor: (LastPaidDueDate) => {
          return moment(LastPaidDueDate.LastPaidDueDate)
            .local()
            .format("MM-DD-YYYY");
        },
      },
    ],
    []
  );
  const searchParameters = useSelector(
    (state: RootState) => state.searchMemberApiSlice
  );

  let memberListAPIParams = {
    ...searchParameters,
    CurrentPage: CurrentAPICallPage,
    SortType: SortType,
    SortBy: SortField,
    Paginate: MembersPerPage ? MembersPerPage : 10,
  };

  console.log("searchParameters3:", refreshCount, ":", searchParameters);

  const hasSearchParamFlags = useSelector(
    (state: RootState) => state.hasSearchParamFlags
  );

  const fromEventtoMember = useSelector(
    (state: RootState) => state.screen.isNavigationfromEventToMember
  );

  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  useEffect(() => {
    console.log("UseEFFECT Called");
    // setCurrentPage(1);
    console.log(fromEventtoMember);
    console.log(roleCapabilites);
    if (fromEventtoMember) {
      // dispatch(changeCurrentMemberMenu(screenConfig.memberDetailScreen));
      dispatch(changeisNavigationFromEventToMember(false));
    }
    console.log("(startIndex:endIndex)", startIndex, ":", endIndex);
    setRefreshCount((prevCount) => prevCount + 1);
    console.log("refresh(Count)", refreshCount);

    console.log("SortType:", SortType);
    console.log("SortField:", SortField);
    console.log("memberListAPIParams.SortType:", memberListAPIParams.SortType);
    console.log(memberListAPIParams);

    const getMemberList = async () => {
      console.log("getAdminList called", refreshCount);
      setIsLoading(true);
      try {
        const response = await MemberServices.getMemberList(memberListAPIParams);

        console.log("isLoading:", isLoading);
        console.log("response...", refreshCount, ":", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          setIsLoading(false);
          return;
        }
        console.log("Success", refreshCount);
        // setMemberList(response.data.data.Members);
        setMemberList((prevMemberList) => [
          ...prevMemberList,
          ...response.data.data.Members,
        ]);
        setCurrentMemberListPage(response.data.data.Members);
        // setCurrentMemberListPage(
        //   response.data.data.Members.slice(startIndex, endIndex)
        // );
        setTotalRecords(response.data.data.Pagination[0].TotalRecords);
        setTotalAPIPages(response.data.data.Pagination[0].TotalAPIPages);
        // setPagination(response.data.data.Pagination);
        dispatch(
          updateMemberList(
            response.data.data.Members.slice(startIndex, endIndex)
          )
        );
        dispatch(setMemberCurrentPage(memberListAPIParams.CurrentPage));
        dispatch(setMemberPaginate(memberListAPIParams.Paginate));
        dispatch(setUpdateSortType(memberListAPIParams.SortType));
        dispatch(setUpdateSortBy(memberListAPIParams.SortBy));
        setIsLoading(false);
        console.log("isLoading:", isLoading);
      } else {
        setIsLoading(false);
      }
      } catch (error) {
        console.error("Error loading members:", error);
        setShowAlertModal(true);
        setAlertTitle("Network Error");
        setAlertBody("Failed to load members. Please check your connection and try again.");
        setIsLoading(false);
      }
    };

    getMemberList();

    // const getConfigurationLists = async () => {
    //   console.log("getAdminList called");
    //   const response = await MemberServices.getConfigurationList();
    //   console.log("response...", response.data.data);
    //   if (response.data.data != null) {
    //     console.log("Success");
    //     console.log("response1...", response.data.data);
    //     setConfigurationLists(response.data.data);
    //   } else {
    //   }
    // };

    // getConfigurationLists();

    console.log("Pagination:", Pagination);
    // Cleanup function: This will be called when the component unmounts
    return () => {
      console.log("Component unmounted");
    };
  }, [
    CurrentAPICallPage,
    SortField,
    SortType,
    isClearSearchCalled,
    MembersPerPage,
  ]);

  const data = useMemo(() => memberList, [memberList]);

  const clearSearch = () => {
    console.log("Clear Search", refreshCount);
    dispatch(resetSearchParameters());
    dispatch(resetSearchParamFlags());

    setCurrentPage(1);
    setCurrentAPICallPage(1);
    setIsClearSearchCalled(true);
    console.log("setCurrentAPICallPage");
    // const getMemberLsit = async () => {
    //   const response = await MemberServices.getMemberList(initialState);
    //   console.log("response...", refreshCount, ":", response.data.data);
    //   if (response.data.data != null) {
    //     console.log("Success", refreshCount);
    //     setMemberList(response.data.data);
    //     dispatch(updateMemberList(response.data.data));
    //   } else {
    //   }
    // };

    // getMemberLsit();
  };

  const TableInstance = useTable(
    {
      columns,
      data,
    },
    useSortBy
  );

  const getMemberDetail = (event: any, member: any) => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("members.view")
      )
    ) {
      alert("No Access");
      return;
    }
    console.log("getMemberDetail:", refreshCount, ":", member.Id);
    console.log("getMemberDetail:", refreshCount, ":", event);
    if (event.target.localName == "td") {
      console.log("ROW clicked", refreshCount);
      dispatch(assignCurrentMember(member));
      dispatch(updateFM_MemberId(member.Id));
      // dispatch(changeCurrentMemberMenu(screenConfig.memberDetailScreen));
      navigate(routeConfig.MEMBER_DETAIL_URL, { replace: false });
    }
    if (event.target.localName == "input") {
      console.log("Checkbox clicked", refreshCount);
      handleRowSelect(event);
    }
    // } else {
    //   alert('Access Denied')
    // }
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    // selectedFlatRows,
  } = TableInstance;

  let index = 0; //to revisit later

  // const download = async () => {
  //   try {
  //     console.log("More", refreshCount);
  //     const response = await MemberServices.downloaMemberList(searchParameters);
  //     const blob = new Blob([response.data], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });
  //     const handle = await (window as any).showSaveFilePicker({
  //       suggestedName: "MemberReport.xlsx",
  //       types: [
  //         {
  //           accept: {
  //             "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
  //               [".xlsx"],
  //             "application/vnd.ms-excel": [".xls"],
  //           },
  //         },
  //       ],
  //     });
  //     const writable = await handle.createWritable();
  //     await writable.write(blob);
  //     await writable.close();
  //     window.alert(`File saved successfully`);
  //   } catch (error) {
  //     if (error === "AbortError") {
  //       console.log("User aborted the download");
  //     } else {
  //       console.error("Error downloading file:", error);
  //     }
  //   }
  // };
  const downloadxl = async () => {
    try {
      console.log("More", refreshCount);
      const response = await MemberServices.downloaMemberList(searchParameters);
      console.log("Response Data:", response.data);
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      // const fileName = "MemberReport.xlsx";
      // await fileSave(blob, { fileName:fileName,extensions: ['.xlsx'] });
      await fileSave(blob, {
        fileName: "MemberReport.xlsx",
        extensions: [".xlsx"],
      });
    } catch (error) {
      if (error === "AbortError") {
        console.log("User aborted the download");
      } else {
        console.error("Error downloading file:", error);
      }
    }
  };
  const handleRowSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name: string = event.target.name;
    const value: boolean = event.target.checked;
    console.log("RC", refreshCount, ":", "name:", name, "-Value", value);

    if (name === "allselect") {
      setIsAllSelected(value);
      const checkedvalue = CurrentMemberListPage?.map((member) => {
        if (value == true) {
          setNoOfSelectedMembers(MembersPerPage);
          return {
            ...member,
            isChecked: true,
          };
        } else {
          setNoOfSelectedMembers(0);
          return {
            ...member,
            isChecked: false,
          };
        }
      });
      // setMemberList(checkedvalue);
      setCurrentMemberListPage(checkedvalue);
      dispatch(updateMemberList(checkedvalue));
    } else {
      const checkedvalue = CurrentMemberListPage?.map((member) => {
        if (member.Id == parseInt(name)) {
          member.isChecked && member.isChecked != null
            ? setNoOfSelectedMembers((prevCount: number) => prevCount - 1)
            : setNoOfSelectedMembers((prevCount: number) => prevCount + 1);
          return {
            ...member,
            isChecked:
              member.isChecked && member.isChecked != null ? false : true,
          };
        } else {
          return member;
        }
      });
      console.log("CheckedMemberList(after):", refreshCount, ":", checkedvalue);
      // setMemberList(checkedvalue);
      setCurrentMemberListPage(checkedvalue);
      dispatch(updateMemberList(checkedvalue));
    }

    console.log("MemberList:", refreshCount, ":", memberList);
  };

  // const handlePageChange = (NextPage: number) => {
  //   startIndex = (NextPage - 1) * MembersPerPage;
  //   endIndex = startIndex + MembersPerPage;
  //   setCurrentMemberListPage(memberList.slice(startIndex, endIndex));
  //   dispatch(updateMemberList(memberList.slice(startIndex, endIndex)));
  //   setCurrentPage(NextPage);
  //   console.log(
  //     "NextPage:",
  //     NextPage,
  //     "-CurrentPage:",
  //     CurrentPage,
  //     "-memberList.length:",
  //     memberList.length,
  //     "-MembersPerPage:",
  //     MembersPerPage
  //   );
  //   if (CurrentPage >= memberList.length / MembersPerPage) {
  //     setCurrentAPICallPage(CurrentAPICallPage + 1);
  //     console.log("setCurrentAPICallPage CALLED");
  //   }
  //   setIsAllSelected(false);
  //   setNoOfSelectedMembers(0);
  //   console.log(
  //     "TotalAPIPages:",
  //     TotalAPIPages,
  //     ",",
  //     "CurrentAPICallPage:",
  //     CurrentAPICallPage,
  //     ",",
  //     startIndex,
  //     ",",
  //     endIndex,
  //     ",",
  //     "memberList.length:",
  //     memberList.length
  //   );
  // };
  const handlePageChange = (value: number) => {
    setCurrentPage(value);
    setCurrentAPICallPage(value);
  };
  const handleSort = (newSortField: string) => {
    console.log("Handle sort called");
    setMemberList([]);
    setCurrentPage(1);
    setCurrentAPICallPage(1);
    startIndex = 0;
    endIndex = 0 + MembersPerPage;
    setSortType(
      newSortField === SortField
        ? SortType === "Desc"
          ? "Asc"
          : "Desc"
        : "Asc"
    );
    setSortField(newSortField);
  };
  const renderSortIcon = (field: string) => {
    if (field === SortField) {
      return SortType === "Desc" ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="27"
          height="30"
          // fill="#fff"
        >
          <path fill="#f6ff00" d="M4 13h16l-8 8z" />
          <path fill="#d5d5d5" d="M12 3l8 8H4z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="27"
          height="30"
          // fill="#fff"
        >
          <path fill="#d5d5d5" d="M4 13h16l-8 8z" />
          <path fill="#f6ff00" d="M12 3l8 8H4z" />
        </svg>
      );
    } else {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="17"
          height="20"
          // fill="#fff"
        >
          <path fill="#d5d5d5" d="M12 3l8 8H4z" />
          <path fill="#d5d5d5" d="M4 13h16l-8 8z" />
        </svg>
      );
    }
  };
  const updateNoOfMembersPerPage = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    setMembersPerPage(Number(event.target.value));
    // setMembersPerAPICall(Number(event.target.value) * 2);
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };

  const SendEmail = () => {
    console.log("Send Email memberList:", CurrentMemberListPage);
    // navigate("/member-email", { replace: true });
    // dispatch(changeCurrentMemberMenu(screenConfig.sendEmailScreen));

    let selectedMemberList = CurrentMemberListPage.filter((member) => {
      return member.isChecked != null && member.isChecked == true
        ? member
        : null;
    });
    console.log("selectedMemberList", selectedMemberList);

    let selectedEmails: string[] = [];
    selectedMemberList.forEach((member) => {
      if (member) {
        if (
          includePrimaryAddress &&
          member &&
          member.PrimaryAddress &&
          member.PrimaryAddress.Email
        ) {
          const primaryEmail = member.PrimaryAddress.Email;
          if (!selectedEmails.includes(primaryEmail)) {
            selectedEmails.push(primaryEmail);
          }
        } //else
        if (
          includePublishedAddress &&
          member &&
          member.PublishedAddress &&
          member.PublishedAddress.Email
        ) {
          const publishedEmail = member.PublishedAddress.Email;
          if (!selectedEmails.includes(publishedEmail)) {
            selectedEmails.push(publishedEmail);
          }
        }
        if (
          includeAdminAddress &&
          member &&
          member.PublishedAddress &&
          member.PublishedAddress.FirmAdminEmailId
        ) {
          const FirmAdminEmailId = member.PublishedAddress.FirmAdminEmailId;
          if (!selectedEmails.includes(FirmAdminEmailId)) {
            selectedEmails.push(FirmAdminEmailId);
          }
        }
      }
    });

    console.log("selectedEmails", selectedEmails);
    const toAddress = selectedEmails.join(",");
    let Subject = "Your Subject...";
    let msgbody = "Your Message...";
    window.open(`mailto:${toAddress}?subject=${Subject}&body=${msgbody}`);

    //     <button onClick={() => window.open(`mailto:${toAddress}?subject=Your Subject&body=Here is the message body`)}>
    //   Compose Email
    // </button>

    // <a href="http://dev.dsba.mavinapps.com/dsba_dev/MemberShipOrder_124436.pdf" download="MemberShipOrder_124436.pdf">
    //   Download PDF
    // </a>
  };

  const FindMember = () => {
    console.log("Find Member");
    navigate("/member/findmember", { replace: false });
    // dispatch(changeCurrentMemberMenu(screenConfig.memberFindScreen));
  };

  const Print = () => {
    console.log("Print");
    // navigate("/member-label", { replace: true });
    dispatch(changeCurrentMemberMenu(screenConfig.printLabelScreen));
  };

  return (
    <>
      {/* <FindMemberMenu
        CurrentMemberListPage={CurrentMemberListPage}
        NoOfSelectedMembers={NoOfSelectedMembers}
      /> */}

      <div
        className="horizontal-wrapper-spacebetween"
        style={{
          marginTop: "0.5rem",
          marginBottom: "0.5rem",
          alignItems: "center",
        }}
        // style={{ paddingTop: "10px", borderTop: "1px solid #ddd" }}
      >
        {/* <div className="d-flex justify-content-between"> */}
        <div className="horizontal-wrapper">
          <h1 className="page-heading">Member List</h1>
          {NoOfSelectedMembers > 0 ? (
            <span
              className="heading_medium"
              style={{ fontWeight: "400", color: "blue" }}
            >
              - {NoOfSelectedMembers} Selected
            </span>
          ) : null}
        </div>

        <div className="d-flex">
          <div className="secondary-button" onClick={FindMember}>
            <FindMemberIcon
              height={30}
              width={30}
              style={{ paddingLeft: "0.3rem" }}
            />
            <span style={{ paddingLeft: "0.3rem", color: "#2d6289" }}>
              Find Member
            </span>
          </div>
          <div
            className="secondary-button"
            onClick={() => {
              NoOfSelectedMembers
                ? setSelectEmailOptionsModalOpen(true)
                : alert("Please select one or more members");
            }}
          >
            <EmailIcon
              height={20}
              width={30}
              style={{ paddingLeft: "0.3rem" }}
            />
            <span style={{ paddingLeft: "0.3rem", color: "#2d6289" }}>
              Send Email
            </span>
          </div>
          <div className="secondary-button" onClick={Print}>
            <PrintIcon height={25} width={25} />
            <span style={{ paddingLeft: "0.3rem", color: "#2d6289" }}>
              Print Name Card
            </span>
          </div>
          {/* <div
            className="secondary-button"
            onClick={downloadxl}
            style={{ paddingRight: "0.3rem" }}
          > */}
          <div
            className="secondary-button"
            onClick={async () => {
              try {
                console.log("Fetching member report...");
                const response = await MemberServices.downloaMemberList(
                  searchParameters
                );

                // Create a Blob from the response
                const blob = new Blob([response.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                // Fallback: Create an <a> element to trigger download
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "MemberReport.xlsx";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                console.log("File saved successfully");
              } catch (error) {
                console.error("Error downloading file:", error);
              }
            }}
            style={{ paddingRight: "0.3rem", cursor: "pointer" }}
          >
            <DownloadIcon height={20} width={20} />
            <span style={{ paddingLeft: "0.3rem", color: "#2d6289" }}>
              Member's Excel
            </span>
          </div>
          <div
            className="secondary-button"
            onClick={() => setIsDownloadModalOpen(true)}
            style={{ paddingRight: "0.3rem", cursor: "pointer" }}
          >
            {isLoading ? (
        <span style={{ color: "#2d6289" }}>Loading...</span>
      ) : (
        <>
          <DownloadIcon height={20} width={20} />
          <span style={{ paddingLeft: "0.3rem", color: "#2d6289" }}>
            Membership Pending Invoice
          </span>
        </>
      )}
          </div>
        </div>
      </div>

      {/* Download Options Modal */}
      <ReactModal
        isOpen={isDownloadModalOpen}
        onRequestClose={() => setIsDownloadModalOpen(false)}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: "2rem",
            borderRadius: "8px",
            maxWidth: "400px",
            width: "90%",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <h3 style={{ marginBottom: "1.5rem", color: "#2d6289", fontSize: "1.25rem", fontWeight: 600 }}>Download Options</h3>
        <div style={{ marginBottom: "1.5rem" }}>
          <div
            className="download-option"
            onClick={() => handleDownloadOption('zip')}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "1rem",
              borderRadius: "6px",
              backgroundColor: "#f8f9fa",
              cursor: isLoading ? "not-allowed" : "pointer",
              opacity: isLoading ? 0.6 : 1,
              marginBottom: "0.75rem",
              transition: "background-color 0.2s ease",
              border: "none",
            }}
          >
            <DownloadIcon height={20} width={20} />
            <span style={{ paddingLeft: "0.75rem", fontSize: "1rem", color: "#2d6289" }}>{isLoading ? 'Downloading...' : 'Download Zip (Multiple Invoice PDFs)'}</span>
          </div>
          <div
            className="download-option"
            onClick={() => handleDownloadOption('merged')}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "1rem",
              borderRadius: "6px",
              backgroundColor: "#f8f9fa",
              cursor: isLoading ? "not-allowed" : "pointer",
              opacity: isLoading ? 0.6 : 1,
              transition: "background-color 0.2s ease",
              border: "none",
            }}
          >
            <DownloadIcon height={20} width={20} />
            <span style={{ paddingLeft: "0.75rem", fontSize: "1rem", color: "#2d6289" }}>{isLoading ? 'Downloading...' : 'Merged PDF'}</span>
          </div>
        </div>
        <div
          onClick={() => setIsDownloadModalOpen(false)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "1rem",
            borderRadius: "6px",
            backgroundColor: "#f0f0f0",
            color: "#2d6289",
            cursor: "pointer",
            transition: "background-color 0.2s ease",
            border: "none",
          }}
        >
          Cancel
        </div>
      </ReactModal>

      <div
        className="dashboard-content-wrapper"
        style={{ paddingBottom: "1rem", marginTop: "0", paddingTop: "0" }}
      >
        {/* Search parameter display */}
        {hasSearchParamFlags.HasOtherSearchParam === true ||
        hasSearchParamFlags.HasInSectionsSearchParam === true ||
        hasSearchParamFlags.HasNotInSectionsSearchParam === true ||
        hasSearchParamFlags.HasInTagsSearchParam === true ||
        hasSearchParamFlags.HasNotInTagsSearchParam === true ? (
          <>
            <div className="horizontal-wrapper">
              <div className="heading_small">Search Result For:</div>
              {/* <div className="secondary-button_small" onClick={clearSearch}>
                <span>(Clear Search)</span>
              </div> */}
            </div>
            <div className="horizontal-wrapper" style={{ margin: "0.2rem" }}>
              {Object.entries(searchParameters).map(([key, value]) =>
                value != null &&
                value != "" &&
                key != "Sections" &&
                key != "Tags" &&
                key != "ExcludedSections" &&
                key != "ExcludedTags" &&
                key != "SectionIn" &&
                key != "TagIn" &&
                key != "SectionNotIn" &&
                key != "TagsNotIn" ? (
                  <div key={key} className="tag-style small-label">
                    {key} = <span style={{ color: "#3366cc" }}>{value}</span>
                  </div>
                ) : (
                  <></>
                )
              )}
              {hasSearchParamFlags.HasInSectionsSearchParam === true &&
              sectionNameArray.length > 0 ? (
                <div className="tag-style small-label">
                  IN Sections:
                  <span style={{ marginLeft: "0.5rem", color: "#3366cc" }}>
                    {sectionNameArray.join(", ")}
                  </span>
                  {/* {Object.entries(searchParameters).map(([key, value]) =>
                    configurationList.MemberSection != undefined ? (
                      configurationList.MemberSection.map((section: any) => {
                        return value != null &&
                          key === "Sections" &&
                          value.includes(section.Id) ? (
                          <span
                            style={{ marginLeft: "0.5rem", color: "#3366cc" }}
                          >
                            {section.SectionName},
                          </span>
                        ) : (
                          <></>
                        );
                      })
                    ) : (
                      <></>
                    )
                  )} */}
                </div>
              ) : (
                <></>
              )}

              {hasSearchParamFlags.HasNotInSectionsSearchParam === true &&
              executeNameArray.length > 0 ? (
                <div className="tag-style small-label">
                  NOT IN Sections:
                  <span style={{ marginLeft: "0.5rem", color: "#3366cc" }}>
                    {executeNameArray.join(", ")}
                  </span>
                  {/* {Object.entries(searchParameters).map(([key, value]) =>
                    configurationList.MemberSection != undefined ? (
                      configurationList.MemberSection.map((section: any) => {
                        return value != null &&
                          key === "ExcludedSections" &&
                          value.includes(section.Id) ? (
                          <span
                            style={{ marginLeft: "0.5rem", color: "#3366cc" }}
                          >
                            {section.SectionName},
                          </span>
                        ) : (
                          <></>
                        );
                      })
                    ) : (
                      <></>
                    )
                  )} */}
                </div>
              ) : (
                <></>
              )}
              {hasSearchParamFlags.HasInTagsSearchParam === true &&
              tagsIn.length > 0 ? (
                <div className="tag-style small-label">
                  IN Tags:
                  <span style={{ marginLeft: "0.5rem", color: "#3366cc" }}>
                    {tagsIn.join(", ")}
                  </span>
                  {/* {Object.entries(searchParameters).map(([key, value]) =>
                    configurationList.MemberTag != undefined ? (
                      configurationList.MemberTag.map((tags: any) => {
                        return value != null &&
                          key === "Tags" &&
                          value.includes(tags.Id) ? (
                          <span
                            style={{ marginLeft: "0.5rem", color: "#3366cc" }}
                          >
                            {tags.MemberTag},
                          </span>
                        ) : (
                          <></>
                        );
                      })
                    ) : (
                      <></>
                    )
                  )} */}
                </div>
              ) : (
                <></>
              )}
              {hasSearchParamFlags.HasNotInTagsSearchParam === true &&
              tagsNotIn.length > 0 ? (
                <div className="tag-style small-label">
                  NOT IN Tags:
                  <span style={{ marginLeft: "0.5rem", color: "#3366cc" }}>
                    {tagsNotIn.join(", ")}
                  </span>
                  {/* {Object.entries(searchParameters).map(([key, value]) =>
                    configurationList.MemberTag != undefined ? (
                      configurationList.MemberTag.map((tags: any) => {
                        return value != null &&
                          key === "ExcludedTags" &&
                          value.includes(tags.Id) ? (
                          <span
                            style={{ marginLeft: "0.5rem", color: "#3366cc" }}
                          >
                            {tags.MemberTag},
                          </span>
                        ) : (
                          <></>
                        );
                      })
                    ) : (
                      <></>
                    )
                  )} */}
                </div>
              ) : (
                <></>
              )}
              <div className="secondary-button1">
                <SecondaryWhiteButton
                  className="secondary-button_small"
                  type="submit"
                  onClick={clearSearch}
                >
                  <span style={{ fontWeight: "500" }}> Clear Search</span>
                </SecondaryWhiteButton>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}

        <div className="memberlist-table" style={{ paddingTop: "0px" }}>
          <table>
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    name="allselect"
                    // checked={isAllSelected}
                    checked={
                      !CurrentMemberListPage.some(
                        (user) => user?.isChecked !== true
                      )
                    }
                    onChange={handleRowSelect}
                  />
                </th>
                <th onClick={() => handleSort("BarId")}>
                  BarID{renderSortIcon("BarId")}
                </th>
                <th onClick={() => handleSort("FirstName")}>
                  FirstName{renderSortIcon("FirstName")}
                </th>
                <th onClick={() => handleSort("LastName")}>
                  LastName{renderSortIcon("LastName")}
                </th>
                <th onClick={() => handleSort("MemberCode")}>
                  MemberCode{renderSortIcon("MemberCode")}
                </th>
                <th onClick={() => handleSort("MemberType")}>
                  MemberType{renderSortIcon("MemberType")}
                </th>
                <th onClick={() => handleSort("AdmitDate")}>
                  AdmitDate{renderSortIcon("AdmitDate")}
                </th>
                <th onClick={() => handleSort("MembershipExpiresOn")}>
                  Due Date{renderSortIcon("MembershipExpiresOn")}
                </th>
              </tr>
            </thead>
            {memberList.length === 0 ? (
              isLoading ? (
                <tbody>
                  <tr>
                    <td align="center" colSpan={9}>
                      <span>Loading:{isLoading}</span>
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td align="center" colSpan={9}>
                      <span>No record Found:{isLoading}</span>
                    </td>
                  </tr>
                </tbody>
              )
            ) : (
              <tbody>
                {CurrentMemberListPage.map((member) => (
                  <tr
                    key={member.Id}
                    onClick={(e) => getMemberDetail(e, member)}
                  >
                    <th>
                      <input
                        type="checkbox"
                        name={member.Id!.toString()}
                        checked={member?.isChecked}
                      />
                    </th>
                    <td>{member.BarId}</td>
                    <td>{member.FirstName} </td>
                    <td>{member.LastName} </td>
                    <td>{member.MemberCode} </td>
                    <td>{member.MemberType} </td>
                    <td>
                      {member.AdmitDate != null
                        ? dayjs(member.AdmitDate).format("MM-DD-YYYY")
                        : "--"}
                    </td>
                    <td>
                      {
                        //const isBeforeFiscalYear = dayjs(member.MembershipExpiresOn).isBefore(currentFiscalYearStart);
                        member.MembershipExpiresOn != null &&
                        dayjs(member.MembershipExpiresOn).isBefore(
                          currentFiscalYearStart
                        ) ? (
                          <>
                            <span style={{ marginRight: "8px" }}>
                              {dayjs(member.MembershipExpiresOn).format(
                                "YYYY-MM-DD"
                              )}
                            </span>
                            <span>(</span>
                            <span style={{ color: "red" }}>Expired</span>
                            <span>)</span>
                            {/* <AlertIcon fill="orange" /> */}
                          </>
                        ) : member.MembershipExpiresOn != null &&
                          dayjs(member.MembershipExpiresOn).isAfter(
                            currentFiscalYearStart
                          ) &&
                          (member.IsCurrentYearDuePaid === 0 ||
                            member.IsCurrentYearDuePaid === null) ? (
                          <>
                            <span style={{ marginRight: "8px", color: "red" }}>
                              {dayjs(member.MembershipExpiresOn).format(
                                "MM-DD-YYYY"
                              )}
                            </span>
                            <AlertIcon fill="orange" />
                            <span>(</span>
                            <span style={{ color: "orange" }}>Due</span>
                            <span>)</span>
                          </>
                        ) : member.MembershipExpiresOn != null &&
                          dayjs(member.MembershipExpiresOn).isAfter(
                            currentFiscalYearStart
                          ) &&
                          member.IsCurrentYearDuePaid === 1 ? (
                          <span style={{ color: "green" }}>No Due</span>
                        ) : (
                          <>{member.Description}</>
                        )
                      }
                    </td>

                    {/* <td>{member.Gender} </td> */}

                    {/* <td>
                      {member.DateOfBirth != null
                        ? dayjs(member.DateOfBirth).format("YYYY-MM-DD")
                        : "--"}
                    </td> */}
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
      {/* Pagination numbers - Begins */}

      {/* <div
        className="horizontal-wrapper-centeraligned"
        style={{ marginTop: "10px" }}
      >
        <div
          className="round-button-div"
          style={{ width: "30px", height: "30px", marginRight: "10px" }}
        >
          <RoundButtonWithIcon
            icon={<LeftArrowIcon height={15} width={8} />}
            onClick={() => handlePageChange(CurrentPage - 1)}
            disabled={CurrentPage === 1}
          />
        </div>

        {CurrentMemberListPage.length > 1 ? (
          <div className="heading_medium">
            {" "}
            <span style={{ fontWeight: "500" }}>
              {1 + (CurrentPage - 1) * MembersPerPage}{" "}
            </span>{" "}
            -{" "}
            <span style={{ fontWeight: "500" }}>
              {CurrentMemberListPage.length +
                (CurrentPage - 1) * MembersPerPage}{" "}
            </span>
            of <span style={{ fontWeight: "500" }}>{TotalRecords} </span>{" "}
            members
          </div>
        ) : (
          <div>
            <div className="heading_medium">
              <span style={{ fontWeight: "500" }}>{TotalRecords} </span> members
            </div>
          </div>
        )}
        <div
          style={{
            height: "30px",
            width: "30px",
            transform: "rotate(180deg)",
            marginLeft: "10px",
          }}
        >
          {" "}
          <RoundButtonWithIcon
            icon={<LeftArrowIcon height={15} width={8} />}
            onClick={() => handlePageChange(CurrentPage + 1)}
            disabled={CurrentPage === Math.ceil(TotalRecords / MembersPerPage)}
          />{" "}
        </div>
      </div> */}
      <div
        className="container "
        style={{
          paddingTop: "10px",
          // borderTop: "1px solid #ddd",
        }}
      >
        <div className="grid left"></div>

        <div className="grid center">
          <div className="horizontal-wrapper-centeraligned">
            <div
              className="round-button-div"
              style={{ width: "30px", height: "30px", marginRight: "10px" }}
            >
              <RoundButtonWithIcon
                icon={<LeftArrowIcon height={15} width={8} />}
                onClick={() => handlePageChange(CurrentPage - 1)}
                disabled={CurrentPage === 1}
              />
            </div>

            {CurrentMemberListPage.length > 1 ? (
              <div className="heading_medium">
                {" "}
                <span style={{ fontWeight: "500" }}>
                  {1 + (CurrentPage - 1) * MembersPerPage}{" "}
                </span>{" "}
                -{" "}
                <span style={{ fontWeight: "500" }}>
                  {CurrentMemberListPage.length +
                    (CurrentPage - 1) * MembersPerPage}{" "}
                </span>
                of <span style={{ fontWeight: "500" }}>{TotalRecords} </span>{" "}
                members
              </div>
            ) : (
              <div>
                <div className="heading_medium">
                  <span style={{ fontWeight: "500" }}>{TotalRecords} </span>{" "}
                  members
                </div>
              </div>
            )}
            <div
              style={{
                height: "30px",
                width: "30px",
                transform: "rotate(180deg)",
                marginLeft: "10px",
              }}
            >
              {" "}
              <RoundButtonWithIcon
                icon={<LeftArrowIcon height={15} width={8} />}
                onClick={() => handlePageChange(CurrentPage + 1)}
                disabled={
                  CurrentPage === Math.ceil(TotalRecords / MembersPerPage)
                }
              />{" "}
            </div>
          </div>
        </div>
        <div className="grid right">
          {/* <div
                    className="input-field-div-wrapper"
                    style={{ margin: "0rem", height: "2rem", width: "3rem" }}
                  > */}
          <select
            className="dropdown-control-large-insidetextfield"
            name="pagesize"
            style={{ border: "1px solid #ddd" }}
            onChange={(e) => {
              updateNoOfMembersPerPage(e);
            }}
            value={MembersPerPage ?? ""}
          >
            {/* <option value={""}>-- Title --</option> */}
            {/* <option value="">
                          {memberApiData?.Personal.Title !== null
                            ? memberApiData?.Personal.Title
                            : "-- Title --"}
                        </option> */}
            <option value="10">10 rows</option>
            <option value="25">25 rows</option>
            <option value="50">50 rows</option>
            <option value="100">100 rows</option>
            <option value="150">150 rows</option>
            <option value="200">200 rows</option>
          </select>
          {/* <p className="form-error form-error-position">{errors.Title?.message}</p> */}
        </div>
      </div>
      {/* </div> */}

      {/* Pagination numbers - Ends */}

      <ReactModal
        isOpen={selectEmailOptionsModalOpen}
        onRequestClose={() => {
          setSelectEmailOptionsModalOpen(false);
        }}
        className="editinfo-modal-small"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Select Email Addresses to include</h1>
          <div className="secondary-button">
            <Button
              type="submit"
              onClick={() => {
                setSelectEmailOptionsModalOpen(false);
              }}
            >
              Close
            </Button>
          </div>
        </div>
        <div
          className="form-wrapper-vertical"
          style={{ marginTop: "15px", marginBottom: "15px" }}
        >
          <label style={{ marginTop: "5px" }}>
            <input
              type="checkbox"
              name="PrimaryAddress"
              // checked={isAllSelected}
              checked={includePrimaryAddress}
              onChange={() => {
                includePrimaryAddress
                  ? setIncludePrimaryAddress(false)
                  : setIncludePrimaryAddress(true);
              }}
            />{" "}
            Primary Email ID
          </label>
          <label style={{ marginTop: "5px" }}>
            <input
              type="checkbox"
              name="PublishedAddress"
              // checked={isAllSelected}
              checked={includePublishedAddress}
              onChange={() => {
                includePublishedAddress
                  ? setIncludePublishedAddress(false)
                  : setIncludePublishedAddress(true);
              }}
            />{" "}
            Published Email ID
          </label>
          <label style={{ marginTop: "5px" }}>
            <input
              type="checkbox"
              name="AdminAddress"
              // checked={isAllSelected}
              checked={includeAdminAddress}
              onChange={() => {
                includeAdminAddress
                  ? setIncludeAdminAddress(false)
                  : setIncludeAdminAddress(true);
              }}
            />{" "}
            Admin Email ID
          </label>
        </div>
        <div className="horizontal-wrapper-centeralign">
          <div className="submit-button-div ">
            <Button type="submit" onClick={SendEmail}>
              Submit
            </Button>
          </div>
        </div>
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default FindMemberList;
